import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import Layout from "@/components/Layout";
import ProtectedRoute from "@/components/ProtectedRoute";
import Landing from "@/pages/Landing";
import RafflesList from "@/pages/RafflesList";
import RaffleDetail from "@/pages/RaffleDetail";
import GuestPurchase from "@/pages/GuestPurchase";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import CreateRaffle from "@/pages/CreateRaffle";
import AdminDashboard from "@/pages/AdminDashboard";
import "@/App.css";

export default function App() {
    return (
        <AuthProvider>
            <BrowserRouter>
                <Layout>
                    <Routes>
                        <Route path="/" element={<Landing />} />
                        <Route path="/rifas" element={<RafflesList />} />
                        <Route path="/rifas/:id" element={<RaffleDetail />} />
                        <Route path="/compra/:id" element={<GuestPurchase />} />
                        <Route path="/login" element={<Login />} />
                        <Route path="/register" element={<Register />} />
                        <Route
                            path="/dashboard"
                            element={
                                <ProtectedRoute>
                                    <Dashboard />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/crear-rifa"
                            element={
                                <ProtectedRoute>
                                    <CreateRaffle />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/admin"
                            element={
                                <ProtectedRoute requireAdmin>
                                    <AdminDashboard />
                                </ProtectedRoute>
                            }
                        />
                    </Routes>
                </Layout>
                <Toaster
                    position="top-right"
                    toastOptions={{
                        style: {
                            border: "2px solid #0A0A0A",
                            borderRadius: 0,
                            background: "#FFFDF7",
                            color: "#0A0A0A",
                            fontWeight: 700,
                            boxShadow: "4px 4px 0px 0px #0A0A0A",
                        },
                    }}
                />
            </BrowserRouter>
        </AuthProvider>
    );
}
